/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PatchedLocationTagRequest
 */
export interface PatchedLocationTagRequest {
  /**
   *
   * @type {string}
   * @memberof PatchedLocationTagRequest
   */
  name?: string
}

/**
 * Check if a given object implements the PatchedLocationTagRequest interface.
 */
export function instanceOfPatchedLocationTagRequest(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function PatchedLocationTagRequestFromJSON(json: any): PatchedLocationTagRequest {
  return PatchedLocationTagRequestFromJSONTyped(json, false)
}

export function PatchedLocationTagRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedLocationTagRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: !exists(json, 'name') ? undefined : json['name'],
  }
}

export function PatchedLocationTagRequestToJSON(value?: PatchedLocationTagRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
  }
}
